import { photoModeFilters } from '~/shared';
import { IPhotoModeService } from './photoModeServiceTypes';

export class PhotoModeServiceStub implements IPhotoModeService {
	public async swapFilter(
		filter: (typeof photoModeFilters)[number],
	): Promise<void> {
		console.log('photoMode:swapFilter', { filter });
	}

	public async resetSettings(): Promise<void> {
		console.log('photoMode:resetSettings');
	}

	public async exit(): Promise<void> {
		console.log('photoMode:exit');
	}
}
